import React from "react";

import { LottieIcon } from "src/shared/ui";
import { LottieIconNames } from "src/shared/config";

export const ScrollArrow: React.FC = () => {
  const scrollDown = () => {
    window.scrollBy({
      top: window.innerHeight - 92,
      behavior: "smooth",
    });
  };

  return (
    <LottieIcon
      icon={LottieIconNames.ARROW_DOWN}
      autoPlay
      loop
      size={180}
      style={{ cursor: "pointer" }}
      onClick={scrollDown}
    />
  );
};
